import "/builds/mit/fe/NEWRR/business-fe/global-os/global-retail-pc/node_modules/core-js/modules/es.array.iterator.js";
import "/builds/mit/fe/NEWRR/business-fe/global-os/global-retail-pc/node_modules/core-js/modules/es.promise.js";
import "/builds/mit/fe/NEWRR/business-fe/global-os/global-retail-pc/node_modules/core-js/modules/es.object.assign.js";
import "/builds/mit/fe/NEWRR/business-fe/global-os/global-retail-pc/node_modules/core-js/modules/es.promise.finally.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import { createApp } from 'vue';
import EcyWatermark from '@mi/ecy-watermark';
import RDPHotkeyInfo from '@mi/rdp-hotkey-info';
import ElementPlus from 'element-plus';
import { createPinia } from 'pinia';
import getApps from './micro/apps';
import { initPerformanceTrack } from './utils/performance';
import { initSentry } from './utils/sentry';
import App from './App.vue';
import i18n from './i18n';
import startQiankun, { setupQiankun } from './micro';
import router from './router';
import '@/styles/base.scss';
import '@/styles/global.scss';
RDPHotkeyInfo.init({
  storageKey: 'userInfo'
});
var title = require('../config').title;
var pinia = createPinia();
var vueApp = createApp(App);
vueApp.use(ElementPlus, {
  // 修改主应用中element前缀，避免子应用样式覆盖
  namespace: 'gp'
});
function initRouter(apps) {
  router.beforeEach(function (to, _from, next) {
    if (to.meta.title) {
      document.title = title;
    }
    var isMatch = apps.some(function (app) {
      var reg = new RegExp("^".concat(app.activeRule, "(/.*)?$"));
      return to.path === '/' || reg.test(to.path);
    });
    // 是否匹配主应用路由
    if (to.name && to.meta.requireAuth === false) {
      next();
      // 若子应用路由匹配不上则返回 404
    } else if (!isMatch && apps.length) {
      next({
        name: '404'
      });
      // path 可以匹配 主应用路由 或者 子应用路由时，判断是否含有cookie值
    } else {
      startQiankun({
        prefetch: false
      });
      // 如果访问根路由，默认跳转第一个子应用
      if (to.path === '/' && apps.length > 0) {
        next(apps[0].activeRule);
      } else {
        next();
      }
    }
  });
}
function mountApp() {
  var _a;
  vueApp.use(router);
  vueApp.use(pinia);
  vueApp.use(ElementPlus);
  vueApp.use(i18n);
  vueApp.use(EcyWatermark);
  vueApp.mount('#main-app');
  // 挂在埋点函数
  if (typeof window.xmot === 'function') {
    window.xmot('init', {
      local: (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('region')) || 'CN',
      appId: '31000402230',
      projectId: 'mi-retail',
      subAppName: String(location.pathname || '').replace(/\/main-([\w-]+)((\/[\w-]+)+)?/gi, '$1') || '',
      privateKey: 'e0c8a21dc4d22b6884eb9e8f348cc3416d13dfaf',
      topic: 'ot_31000402230_' + (((_a = JSON.parse((localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('regionData')) || '{}')) === null || _a === void 0 ? void 0 : _a.region) || 'sg')
    });
    window.xmot('clickAuto');
    window.xmot('exposeAuto');
  }
}
function setup() {
  // 在应用启动前初始化 Sentry，确保错误捕获正常工作
  initSentry(vueApp, router);
  initPerformanceTrack();
  getApps().then(function (apps) {
    if (Array.isArray(apps)) {
      initRouter(apps);
      setupQiankun(apps);
    }
    mountApp();
  });
}
setup();